import { useState } from "react";
import Input from "../../../../Core/Fields/Floating/Input";
import Textarea from "../../../../Core/Fields/Floating/Textarea";
import SelectSearch from "../../../../Core/Fields/Floating/SelectSearch";
import ActivityCard from "../../../../Core/Activity/ActivityCard";
const Tab1 = ({
  IdData,
  ModeofPayment,
  DueDateBasedOn,
  PaymentTermName,
  CreditDays,
  InvoicePortion,
  DiscountType,
  Discount,
  DiscountValidityBasedOn,
  DiscountValidity,
  Description,
}) => {
  return (
    <>
      <div
        className="row mb-3"
        style={{ border: "1px solid #00000059", borderRadius: "5px" }}
      >
        <div className="col-12">
          <p className="boxLabel m-0">Details</p>
        </div>
        <div className="col-2" style={{
          width: "290px",
        }}>
          <div className="mb-3">
            <Input
              id="PaymentTermName"
              label="Payment Term Name"
              style={{
                height: "30px",

                border: PaymentTermName.Error ? "1px solid red" : "",
              }}
              value={PaymentTermName.PaymentTermName}
              onChange={(e) =>
                PaymentTermName.setPaymentTermName(e.target.value)
              }
              readOnly
            />

          </div>
        </div>
        <div className="col-2" style={{
          width: "290px",
        }}>
          <div className="mb-3">
            <Input
              id="InvoicePortion"
              label="Invoice Portion (%)"
              style={{
                height: "30px",
                border: InvoicePortion.Error ? "1px solid red" : "",
              }}
              value={InvoicePortion.InvoicePortion}
              onChange={(e) => InvoicePortion.setInvoicePortion(e.target.value)}
              readOnly
            />
          </div>
        </div>
        <div className="col-2" style={{
          width: "290px",
        }}>
          <div className={ModeofPayment.Error ? `mb-3 errorborder` : `mb-3`}>
            <Input
              id="ModeofPayment"
              label="Mode of Payment"
              style={{
                height: "30px",
              }}
              value={ModeofPayment.select_ModeofPayment}
              readOnly
            />

          </div>
        </div>
        <div className="col-2" style={{
          width: "290px",
        }}>
          <div className={DueDateBasedOn.Error ? `mb-3 errorborder` : `mb-3`}>
            <Input
              id="DueDateBasedOn"
              label="Due Date Based On"
              style={{
                height: "30px",
              }}
              value={DueDateBasedOn.select_DueDateBasedOn}
              readOnly
            />

          </div>
        </div>
        <div className="col-2" style={{
          width: "290px",
        }}>
          <div className="mb-3">
            <Input
              id="CreditDays"
              label="Credit Days"
              style={{
                height: "30px",
                border: CreditDays.Error ? "1px solid red" : "",
              }}
              readOnly
              value={CreditDays.CreditDays}
              onChange={(e) => CreditDays.setCreditDays(e.target.value)}

            />
          </div>
        </div>
      </div>
      <div
        className="row mb-3"
        style={{ border: "1px solid #00000059", borderRadius: "5px" }}
      >
        <div className="col-12">
          <p className="boxLabel m-0">Discount Settings </p>
        </div>

        <div className="col-4">
          <div className="mb-3">
            <Input
              id="DiscountType"
              label="Discount Type"
              style={{
                height: "30px",
              }}
              value={DiscountType.select_DiscountType}
              readOnly
            />

          </div>
        </div>

        <div className="col-4">
          <div className="mb-3">
            <Input
              id="Discount"
              label="Discount"
              style={{
                height: "30px",
                border: Discount.Error ? "1px solid red" : "",
              }}
              readOnly
              value={Discount.Discount}
              onChange={(e) => Discount.setDiscount(e.target.value)}
            />
          </div>
        </div>
        {String(Discount.Discount).trim() !== "" && (
          <>
            <div className="col-4" >
              <div className="mb-3">
                <Input
                  id="DiscountValidityBasedOn"
                  label="Discount Validity Based On"
                  style={{
                    height: "30px",
                  }}
                  value={DiscountValidityBasedOn.DiscountValidityBasedOn}
                  readOnly
                />

              </div>
            </div>


            <div className="col-4">
              <div className="mb-3">
                <Input
                  id="DiscountValidity"
                  label="Discount Validity"
                  style={{
                    height: "30px",
                    // border: Discount.Error ? "1px solid red" : "",
                  }}
                  readOnly
                  value={DiscountValidity.DiscountValidity}
                  onChange={(e) => DiscountValidity.setDiscountValidity(e.target.value)}
                />
              </div>
            </div>

          </>
        )}
        <div className="col-4">
          <div className="mb-3">
            <Textarea
              id="Description"
              label="Description"
              style={{
                height: "30px",
                border: Description.Error ? "1px solid red" : "",
              }}
              readOnly
              value={Description.Description}
              onChange={(e) => Description.setDescription(e.target.value)}
            />
          </div>
        </div>
      </div>
      <div className="">
        <ActivityCard doctype="Payment Term" docname={IdData} />
      </div>

    </>
  );
};

export default Tab1;
